<ion-item *ngIf="title" class="title" lines="none" [style.color]="color ? 'var(--ion-color-' + color + ')' : null">
    <upp-icon *ngIf="icon && !image" [slot]="slot" [name]="icon!" [color]="iconColor"></upp-icon>
    <upp-image *ngIf="!icon && image" slot="start" [name]="image"></upp-image>
    <ion-label>
        {{title}}
        <div *ngIf="subtitle" class="small subtitle">{{subtitle}}</div>
    </ion-label>
    <ng-content select="upp-form-section-end"></ng-content>
</ion-item>
<ion-list>
    <ng-content></ng-content>
</ion-list>
